import { ECaseCardStatus } from '#shared';

import { ENOPCaseStatus } from '../../enums';

export const STATUS_COLORS: Record<ECaseCardStatus, string> = {
  [ECaseCardStatus.Ok]: '',
  [ECaseCardStatus.Warning]: '#FF3844',
  [ECaseCardStatus.Accept]: '#00E733',
  [ECaseCardStatus.Error]: '',
};

export const CASE_STATUS_INDEX: Record<ENOPCaseStatus, number> = {
  [ENOPCaseStatus.None]: 0,
  [ENOPCaseStatus.Draft]: 1,
  [ENOPCaseStatus.TXCenterDraft]: 2,
  [ENOPCaseStatus.New]: 3,
  [ENOPCaseStatus.ClinicalScreening]: 4,
  [ENOPCaseStatus.OrTimeConfirmed]: 5,
  [ENOPCaseStatus.Accepted]: 6,
  [ENOPCaseStatus.PendingLogistics]: 7,
  [ENOPCaseStatus.ResourcesBooked]: 8,
  [ENOPCaseStatus.ResourceDeployed]: 9,
  [ENOPCaseStatus.AtDonorHospital]: 10,
  [ENOPCaseStatus.OrganOnOCS]: 11,
  [ENOPCaseStatus.DeployedToTXCenter]: 12,
  [ENOPCaseStatus.AtTXCenter]: 13,
  [ENOPCaseStatus.OrganOffOCS]: 14,
  [ENOPCaseStatus.ServiceCompleted]: 15,
  [ENOPCaseStatus.ServiceDeclined]: 16,
  [ENOPCaseStatus.ReturningToBase]: 17,
  [ENOPCaseStatus.Declined]: 18,
  [ENOPCaseStatus.Finished]: 19,
  [ENOPCaseStatus.Closed]: 20,
  [ENOPCaseStatus.Deleted]: 21,
};
